// extracted by mini-css-extract-plugin
export var cashback100 = "howSteps-module--cashback100--26u6-";
export var cashback_factory = "howSteps-module--cashback_factory--fPk2u";
export var plait = "howSteps-module--plait--yVF+D";
export var section = "howSteps-module--section--hTWJX";
export var step = "howSteps-module--step--2jQTs";
export var stepNumber = "howSteps-module--stepNumber--dfdTF";
export var steps = "howSteps-module--steps--Mrf3h";
export var text = "howSteps-module--text--0nCEt";
export var title = "howSteps-module--title--+52nK";